import React from 'react';
import { createRoot } from 'react-dom/client';
// import {SyncComponent} from "@react/components/sync_component";
import { AsyncComponent } from '@react/components/async_component';

export const renderComponent = (componentPath, selector, props = {}) => {
  const container = document.querySelector(selector);

  if (!container) return;

  let root = container._reactRoot; // Store the root instance on the container
  if (!root) {
    root = createRoot(container); // Create the root only if it doesn't exist
    container._reactRoot = root; // Store the root for future reference
  }

  // Safely parse props if necessary (assuming they are JSON strings)
  if (props && typeof props === 'string') {
    try {
      props = JSON.parse(props);
    } catch (error) {
      console.error('Invalid props format:', error);
    }
  }

  // Render the component with the given props
  // eslint-disable-next-line
  root.render(<AsyncComponent componentPath={componentPath} {...props} />);
};

export const renderComponents = (componentPath, selectorList) => {
  const selectors = document.querySelectorAll(selectorList);
  selectors.forEach((selector) => {
    const props = selector.getAttribute('data-props');
    renderComponent(componentPath, selector, props);
  });
};
